module.exports = __webpack_public_path__ + "img/talk-img1.61d80e76.png";